import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withGlobalFilter } from '@bingads-webui-react/global-filter-context';
import { CampaignType, siteMapPropType, getCurrentScope } from '@bingads-webui-react/with-site-map';
import { WaterfallFilterType } from '@bingads-webui/filter-commons';
import { filterMapItem, getFilteredCampaignType } from './processor-helpers';

const defaultCampaign = { CampaignType: CampaignType.All };

function hotelCampaignFilter(
  campaign,
  globalCampaignType,
  currentScope,
  { hotelCampaignScope }
) {
  const isHotelCampaign = campaign && campaign.Id ?
    campaign.CampaignType === 'Hotel' :
    false;

  const isGlobalHotelCampaign = globalCampaignType === CampaignType.Hotel;

  if ((isHotelCampaign || isGlobalHotelCampaign) && hotelCampaignScope &&
    !_.contains(hotelCampaignScope, currentScope)) {
    // Hide page not support in current scope.
    return false;
  }
  return true;
}

const filterMapItemByCampaign = (siteMap, globalCampaignType, currentScope, currentCampaign) => {
  const campaignFilter = (campaign, item) =>
    hotelCampaignFilter(campaign, globalCampaignType, currentScope, item);

  return filterMapItem(siteMap, _.partial(campaignFilter, currentCampaign));
};

const filterMapItemByCampaignCached = memoize(filterMapItemByCampaign);

/**
 * Only for testing
 */
export const testRef = { current: undefined };

export function processHotelCampaign(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const {
      scope: { values: { aid, campaignId, adGroupId } },
    } = props;
    const currentScope = getCurrentScope(campaignId, adGroupId, aid);
    const globalCampaignType
      = getFilteredCampaignType(props[WaterfallFilterType.CampaignType]);

    const processor = campaign => (<Component
      {...props}
      siteMap={filterMapItemByCampaignCached(siteMap, globalCampaignType, currentScope, campaign)}
    />);

    return (
      <CampaignOData
        call={({ currentCampaign }) => currentCampaign.get()}
        escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : {})}
        fallback={processor(defaultCampaign)}
        onError={() => processor(defaultCampaign)}
        testRef={testRef}
      >
        {campaign => processor(campaign)}
      </CampaignOData>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return withGlobalFilter(withScope(Wrapper));
}
